import queryString from 'query-string';
import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';
import { GenerateStatementApi, SaveCommissionPayoutsApi, SaveTransactionsApi, AdjustTransactionApi, AdjustCommissionApi, SaveManagerStatementDetailsApi, SaveManagerStatementCleaningApi, List } from '../interfaces/managerStatement.interface';

const list = (payload: List) => {
  const { searchText, startDate, endDate, managedBy, status, ...others } = payload;
  const paging = buildPagingResponse(others);

  const url = `${API_ENDPOINTS.listManagerStatements}?${queryString.stringify(paging)}`;
  return http.post(url, {
    date_from: startDate || undefined,
    date_to: endDate || undefined,
    manager_id: managedBy || undefined,
    status: status || undefined,
    search: searchText || undefined,
  });
};

const generate = (payload: GenerateStatementApi) => {
  return http.post(API_ENDPOINTS.generateManagerStatement, payload);
};

const get = (id: string) => {
  return http.get(API_ENDPOINTS.getManagerStatement(id));
};

const updateDetails = (id: string, payload: SaveManagerStatementDetailsApi) => {
  return http.put(API_ENDPOINTS.getManagerStatement(id), payload);
};

const getCommissionPayouts = (id: string) => {
  return http.get(API_ENDPOINTS.getManagerStatementCommissionPayouts(id));
};

const saveCommissionPayouts = (id: string, payload: SaveCommissionPayoutsApi) => {
  return http.post(API_ENDPOINTS.getManagerStatementCommissionPayouts(id), payload);
};

const adjustCommissionPayout = (id: string, invoiceId: string, payload: AdjustCommissionApi) => {
  return http.put(API_ENDPOINTS.adjustManagerStatementCommissionPayout(id, invoiceId), payload);
};

const getTransactions = (id: string) => {
  return http.get(API_ENDPOINTS.getManagerStatementTransactions(id));
};

const saveTransactions = (id: string, payload: SaveTransactionsApi) => {
  return http.post(API_ENDPOINTS.getManagerStatementTransactions(id), payload);
};

const adjustTransaction = (id: string, transactionId: string, payload: AdjustTransactionApi) => {
  return http.put(API_ENDPOINTS.adjustManagerStatementTransaction(id, transactionId), payload);
};

const saveCleaning = (id: string, payload: SaveManagerStatementCleaningApi) => {
  return http.put(API_ENDPOINTS.saveManagerStatementCleaning(id), payload);
};

const getPropertyVisitBifurcation = (id: string, invoiceId: string) => {
  return http.get(API_ENDPOINTS.getManagerStatementPropertyVisitBifurcation(id, invoiceId));
};

const getStatementDocument = (id: string) => {
  return http.get(API_ENDPOINTS.getManagerStatementDocument(id));
};

const getInvoiceDocument = (id: string) => {
  return http.get(API_ENDPOINTS.getManagerStatementInvoiceDocument(id));
};

const uploadInvoiceDocument = (id: string, file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return http.post(API_ENDPOINTS.getManagerStatementInvoiceDocument(id), formData, {
    headers: { 'Content-Type': undefined as any },
  });
};

const deleteInvoiceDocument = (id: string) => {
  return http.delete(API_ENDPOINTS.getManagerStatementInvoiceDocument(id));
};

const deleteStatement = (id: string) => {
  return http.delete(API_ENDPOINTS.getManagerStatement(id));
};

const ManagerStatementService = {
  list,
  generate,
  get,
  updateDetails,
  getCommissionPayouts,
  saveCommissionPayouts,
  adjustCommissionPayout,
  getTransactions,
  saveTransactions,
  adjustTransaction,
  saveCleaning,
  getPropertyVisitBifurcation,
  getStatementDocument,
  getInvoiceDocument,
  uploadInvoiceDocument,
  deleteInvoiceDocument,
  deleteStatement,
};

export default ManagerStatementService;
